export default (initialState, factories) => (state = initialState, action) => {
    if (factories[action.type]) {
      return factories[action.type](state, action);
    }
  
    return state;
  };
  